import { useState } from "react";
import Sidebar from "./Sidebar";

function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <div className="d-flex h-100 position-relative">

        {/* ===== SIDEBAR ===== */}
        <Sidebar
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
        />

        {/* ===== MAIN CONTENT ===== */}
        <div
          className="flex-grow-1 d-flex flex-column"
          style={{
            backgroundColor: "#f4f6f9",
            transition: "margin-left 0.3s ease",
            marginLeft:
              window.innerWidth > 768
                ? collapsed
                  ? "80px"
                  : "250px"
                : "0px"
          }}
        >
          {/* TOP BAR */}
          <div className="d-flex align-items-center p-3 bg-white shadow-sm">
            {/* Mobile toggle */}
            <button
              className="btn btn-outline-dark d-md-none me-2"
              onClick={() => setMobileOpen(true)}
            >
              ☰
            </button>

            {/* Desktop toggle */}
            <button
              className="btn btn-outline-dark d-none d-md-block"
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed ? "→" : "←"}
            </button>

            <h5 className="mb-0 ms-3">Star Laser ERP</h5>
          </div>

          {/* Scrollable Content */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "24px"
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;